import { DEFAULT_SORT } from '@utils/constants';
import { metricKeys } from '@pulse/metrics';
import { DEFAULT_DIMENSIONS, WIDGET_TYPES, DEFAULT_FILTER } from '@src/utils/kpi';
import moment from 'moment';
import { getDateShortcuts } from '@components/overview-dashboard/overview-date-picker/dateUtils';

export const initialFilter = {
  appliedFilters: [DEFAULT_FILTER],
  sort: DEFAULT_SORT,
  breadcrumb: [DEFAULT_FILTER],
};

export const initialWidgets = [
  {
    type: WIDGET_TYPES.audienceMetrics,
    config: {},
  },
  {
    type: WIDGET_TYPES.spi,
    config: {
      thresholdType: 'conviva-good',
      thresholdConfig: {},
    },
  },
  {
    type: WIDGET_TYPES.subOpportunities,
    config: {},
  },
  {
    type: WIDGET_TYPES.dimensionTable,
    config: {
      dimensions: DEFAULT_DIMENSIONS,
      unit: '%',
    },
  },
];

export const initialMetric = metricKeys.StreamingPerformanceIndex;

const shortcuts = getDateShortcuts();
const [shortcut, interval] = shortcuts[0];

export const initialInterval = {
  from: moment(interval[0]).format(),
  to: moment(interval[1]).format(),
  shortcut,
};
